<template>
  <el-dialog
    width="340px"
    v-model="dialogShow"
    align-center
    class="custom_dialog_more"
    :show-close="false"
    :destroy-on-close="true"
  >
    <div class="verify_dialog_container">
      <div class="div_header">
        <h4>验证弹窗</h4>
        <el-icon 
          @click="dialogShow = false" 
          class="i_close cp_us hover"
          size="18px"
        ><Close /></el-icon>
      </div>
      <Vcode 
        :show="true"
        type="inside" 
        ref="vCodeRef"
        :canvasWidth="300"
        :canvasHeight="200"
        :puzzleScale="1"
        :sliderSize="30"
        :range="10"
        :imgs="[
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img1.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img2.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img3.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img4.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img5.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img6.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img7.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img8.jpeg',
          'https://image.keymemox.com/images/conbrie/login_verify_imgs/img9.jpeg',
        ]"
        sliderText="请向右滑动 完成拼图"
        className="findPassword-code"
        @success="onSuccess"
        @close="onClose"
      />
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import Vcode from "vue3-puzzle-vcode";

const emits = defineEmits(["verifySuccess"])
// ---ref---
let vCodeRef = ref(null); // 验证码组件

let dialogShow = ref(false);

function openDialog(){
  dialogShow.value = true;
}

// 验证通过
function onSuccess(){
  dialogShow.value = false;
  emits("verifySuccess")
}

// 验证失败
function onClose(){
  vCodeRef.value.reset();
}

defineExpose({
  openDialog,
})
</script>

<style lang='scss' scoped>
.verify_dialog_container{
  padding: 20px;
  .div_header{
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;
    text-align: center;
    font-size: 16px;
    color: #000000;
    margin-bottom: 20px;
    .i_close{
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      position: absolute;
      top: 0px;
      right: 0px;
      font-size: 15px;
      color: #999999;
    }
  }
}
</style>